
const _directiveDependencies = ['Templates'];
const _controllerDependencies = ['Util'];

class PhoneEmailDeploymentSuccessController {

    constructor(Util) {

        this.Util = Util;

    }

    close() {

        this.Util.closeModal();

    }

}

class PhoneEmailDeploymentSuccessDirective {

    constructor() {

        this.template = require('./phone-email-deployment-success.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push(Util =>
            new PhoneEmailDeploymentSuccessController(Util));

        this.controller = _controllerDependencies;
        this.controllerAs = 'PhoneEmailDeploymentSuccessCtrl';

    }

}

_directiveDependencies.push(() =>
    new PhoneEmailDeploymentSuccessDirective());

angular.module('directives')
    .directive('phoneEmailDeploymentSuccess', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/deployment/phone-email-deployment-success/phone-email-deployment-success.js